/**
 * Local Delivery - API fetch for planners.dand3.com
 */
(function () {
  'use strict';

  var API_BASE = 'https://planners.dand3.com';
  var STORE_KEY_FALLBACK = 'WF';
  var ATTRIBUTION_SESSION_KEY = 'wf_attr_session_v1';
  var CART_FORM_SESSION_KEY = 'wf_ld_cart_form_session_v1';
  var lastPublicConfigResult = null;

  function normalizeStoreKey(value) {
    var key = String(value || '').trim().toUpperCase();
    return /^[A-Z0-9_-]+$/.test(key) ? key : '';
  }

  function getRuntimeStoreKeyCandidate() {
    if (window.WF_LD_RUNTIME && window.WF_LD_RUNTIME.storeKey) return window.WF_LD_RUNTIME.storeKey;
    if (window.WF_LD_STORE_KEY) return window.WF_LD_STORE_KEY;
    return '';
  }

  function getStoreKey() {
    return normalizeStoreKey(getRuntimeStoreKeyCandidate()) || STORE_KEY_FALLBACK;
  }

  function setStoreKey(nextKey) {
    var normalized = normalizeStoreKey(nextKey) || STORE_KEY_FALLBACK;
    window.WF_LD_RUNTIME = window.WF_LD_RUNTIME || {};
    window.WF_LD_RUNTIME.storeKey = normalized;
    return normalized;
  }

  function buildDeliveryUrl(pathAndQuery) {
    return API_BASE + '/api/delivery/' + encodeURIComponent(getStoreKey()) + pathAndQuery;
  }

  function nowMs() {
    try {
      if (window.performance && typeof window.performance.now === 'function') return window.performance.now();
    } catch (_) {}
    return Date.now();
  }

  function setLastPublicConfigResult(result) {
    lastPublicConfigResult = result || null;
    return lastPublicConfigResult;
  }

  function getLastPublicConfigResult() {
    if (!lastPublicConfigResult) return null;
    var copy = {};
    Object.keys(lastPublicConfigResult).forEach(function (key) {
      copy[key] = lastPublicConfigResult[key];
    });
    return copy;
  }

  function elapsedSince(startedAt) {
    return Math.max(0, Math.round(nowMs() - startedAt));
  }

  function describeFetchError(err) {
    if (!err) return 'Unknown fetch error';
    if (err && err.name && err.message) return String(err.name + ': ' + err.message).slice(0, 500);
    if (err && err.message) return String(err.message).slice(0, 500);
    return String(err).slice(0, 500);
  }

  function fetchPublic() {
    var url = buildDeliveryUrl('/public?_t=' + Date.now());
    var startedAt = nowMs();
    setLastPublicConfigResult({ ok: false, reason: 'pending', url: url, elapsedMs: 0 });
    return fetch(url, { credentials: 'omit', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) {
          return r.text().then(function (text) {
            setLastPublicConfigResult({
              ok: false,
              reason: 'http_error',
              statusCode: r.status,
              detail: (text || r.statusText || '').slice(0, 500),
              url: url,
              elapsedMs: elapsedSince(startedAt),
            });
            return null;
          }).catch(function () {
            setLastPublicConfigResult({
              ok: false,
              reason: 'http_error',
              statusCode: r.status,
              detail: r.statusText || '',
              url: url,
              elapsedMs: elapsedSince(startedAt),
            });
            return null;
          });
        }
        return r.json().then(function (data) {
          setLastPublicConfigResult({
            ok: true,
            reason: 'ok',
            statusCode: r.status,
            url: url,
            elapsedMs: elapsedSince(startedAt),
          });
          return data;
        }).catch(function (err) {
          setLastPublicConfigResult({
            ok: false,
            reason: 'json_parse_error',
            statusCode: r.status,
            detail: describeFetchError(err),
            url: url,
            elapsedMs: elapsedSince(startedAt),
          });
          return null;
        });
      })
      .catch(function (err) {
        setLastPublicConfigResult({
          ok: false,
          reason: 'fetch_error',
          detail: describeFetchError(err),
          url: url,
          elapsedMs: elapsedSince(startedAt),
        });
        return null;
      });
  }

  function fetchValidatePostal(code) {
    if (!code || String(code).length !== 6) return Promise.resolve(null);
    return fetch(buildDeliveryUrl('/validate-postal?code=' + encodeURIComponent(code)), { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function fetchAvailability(dateStr) {
    if (!dateStr || !/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return Promise.resolve(null);
    return fetch(buildDeliveryUrl('/availability?date=' + encodeURIComponent(dateStr) + '&_t=' + Date.now()), { credentials: 'omit', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function createCheckout(data) {
    return fetch(buildDeliveryUrl('/checkout'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'omit',
      body: JSON.stringify(data),
    })
      .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { return Promise.reject(e); }); })
      .catch(function (err) { return Promise.reject(err); });
  }

  function fetchSeasonal() {
    return fetch(
      API_BASE + '/api/seasonal/public?storeKey=' + encodeURIComponent(getStoreKey()) + '&_t=' + Date.now(),
      { credentials: 'omit', cache: 'no-store' }
    )
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  var TELEMETRY_DEDUP_MS = 5 * 60 * 1000;
  var telemetryRecent = {};
  var cartFormRecent = {};

  function getSessionStorage() {
    try {
      if (window.sessionStorage) return window.sessionStorage;
    } catch (_) {}
    try {
      return sessionStorage;
    } catch (_) {}
    return null;
  }

  function parseJson(raw, fallback) {
    if (!raw) return fallback;
    try {
      return JSON.parse(raw);
    } catch (_) {
      return fallback;
    }
  }

  function getAttributionSessionId() {
    var storage = getSessionStorage();
    if (!storage) return '';
    var session = parseJson(storage.getItem(ATTRIBUTION_SESSION_KEY), null);
    if (session && typeof session.sessionId === 'string' && session.sessionId) {
      return session.sessionId;
    }
    return '';
  }

  function getCartFormSessionId() {
    var attributionSessionId = getAttributionSessionId();
    if (attributionSessionId) return attributionSessionId;
    var storage = getSessionStorage();
    if (!storage) return '';
    var existing = String(storage.getItem(CART_FORM_SESSION_KEY) || '').trim();
    if (existing) return existing;
    var generated = 'wf-ld-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    try {
      storage.setItem(CART_FORM_SESSION_KEY, generated);
    } catch (_) {}
    return generated;
  }

  function normalizeEmail(value) {
    var normalized = String(value || '').trim().toLowerCase();
    return (normalized && normalized.indexOf('@') > 0) ? normalized.slice(0, 320) : '';
  }

  function reportEvent(event, meta) {
    if (!event) return;
    var dedupKey = event + ':' + String((meta && meta.variantId) || '');
    var now = Date.now();
    if (telemetryRecent[dedupKey] && (now - telemetryRecent[dedupKey]) < TELEMETRY_DEDUP_MS) return;
    telemetryRecent[dedupKey] = now;
    var payload = {
      event: event,
      variantId: (meta && meta.variantId) ? String(meta.variantId) : undefined,
      statusCode: (meta && meta.statusCode) ? Number(meta.statusCode) : undefined,
      reason: (meta && meta.reason) ? String(meta.reason).slice(0, 100) : undefined,
      elapsedMs: (meta && typeof meta.elapsedMs !== 'undefined') ? Number(meta.elapsedMs) : undefined,
      configUrl: (meta && meta.configUrl) ? String(meta.configUrl).slice(0, 500) : undefined,
      detail: (meta && meta.detail) ? String(meta.detail).slice(0, 500) : undefined,
      page: location.pathname,
      ts: now,
    };
    try {
      fetch(buildDeliveryUrl('/telemetry'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(function () {});
    } catch (_) {}
  }

  function reportCartFormInteraction(event, meta) {
    if (!event) return;
    var sessionId = getCartFormSessionId();
    if (!sessionId) return;
    var now = Date.now();
    var normalizedEmail = normalizeEmail(meta && meta.senderEmail);
    var dedupKey = sessionId + ':' + event + ':' + normalizedEmail;
    if (cartFormRecent[dedupKey] && (now - cartFormRecent[dedupKey]) < TELEMETRY_DEDUP_MS) return;
    cartFormRecent[dedupKey] = now;

    var payload = {
      sessionId: sessionId,
      event: String(event),
      page: (typeof location !== 'undefined' && location && location.pathname) ? location.pathname : '/',
      ts: now,
      senderEmail: normalizedEmail || undefined,
      deliveryMethod: (meta && meta.deliveryMethod) ? String(meta.deliveryMethod) : undefined,
    };

    try {
      fetch(buildDeliveryUrl('/cart-form-metrics'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(function () {});
    } catch (_) {}
  }

  window.WF_LD_API = {
    API_BASE: API_BASE,
    getStoreKey: getStoreKey,
    setStoreKey: setStoreKey,
    buildDeliveryUrl: buildDeliveryUrl,
    fetchPublic: fetchPublic,
    getLastPublicConfigResult: getLastPublicConfigResult,
    fetchValidatePostal: fetchValidatePostal,
    fetchAvailability: fetchAvailability,
    createCheckout: createCheckout,
    fetchSeasonal: fetchSeasonal,
    reportEvent: reportEvent,
    reportCartFormInteraction: reportCartFormInteraction,
  };
})();
